import { FC } from 'react';
import particle from '../../../../public/images/particle.png';
import classNames from 'classnames';
import CustomImage from '@/components/CustomImage/CustomImage';

interface Props {
    summary: string;
    shortText: string;
    size?: 'small' | 'big';
}

const QuotedTextBlock: FC<Props> = ({ summary, shortText, size = 'big' }) => {
    return (
        <article className="tw-w-full md:tw-max-w-[495px]  lg:tw-max-w-[423px] tw-mx-auto">
            <div className="tw-w-full tw-px-[23px] tw-py-[12px] tw-bg-[#ce0058] tw-rounded-lg">
                <p
                    className={classNames('tw-font-gotham-medium tw-text-white', {
                        'tw-text-[18px] lg:tw-text-[22px] tw-leading-7': size === 'big',
                        'tw-text-[16px]': size === 'small',
                    })}
                >
                    {summary}
                </p>
            </div>
            <div className="tw-w-full tw-flex tw-justify-between tw-align-top">
                <CustomImage src={particle} alt="particle" className="tw-h-[36px]" />
                <div className="tw-flex tw-justify-end tw-items-start">
                    <div className="tw-text-textBase tw-max-w-[330px] tw-text-right tw-font-gotham-book  tw-text-[12px] tw-pt-[10px]">
                        {shortText}
                    </div>
                </div>
            </div>
        </article>
    );
};

export default QuotedTextBlock;
